import styled from 'styled-components';

type ColorListItemProps = {
    backgroundColor: string;
};

export const ColorListItem = styled.li<ColorListItemProps>`
    background-color: ${(props) => '#' + props.backgroundColor};
`;
